import Vue from 'vue'
import Router from 'vue-router'
import DefLayout from '../layout/DefLayout.vue'
import BlankLayout from '../layout/BlankLayout.vue'
import Index from '../pages/index.vue'
import programme from '../pages/programme.vue'
import cases from '../pages/cases.vue'
import price from '../pages/price.vue'
import sVip from '../pages/sVip.vue'
import agent from '../pages/agent.vue'
import dispute from '../pages/dispute.vue'
import examine from '../pages/examine.vue'
import about from '../pages/about.vue'
import job from '../pages/job.vue'
import funs from '../pages/funs.vue'
import scene from '../pages/scene.vue'
import ktv2 from '../pages/ktv.vue'

Vue.use(Router);

export default new Router({
	routes: [
		{
			path: '/',
			component: DefLayout, 
			meta: {
				title: 'MOMI智慧自助空间系统'
			},
			children: [
				{
					path: '',
					name: 'Index',
					component: Index
				}, {
					path: '/programme',
					name: 'programme',
					component: programme
				}, {
					path: '/cases',
					name: 'cases',
					component: cases
				}, {
					path: '/price',
					name: 'price',
					component: price
				}, {
					path: '/sVip',
					name: 'sVip',
					component: sVip
				}, {
					path: '/agent',
					name: 'agent',
					component: agent
				}, {
					path: '/funs',
					name: 'funs',
					component: funs
				}, {
					path: '/scene',
					name: 'scene',
					component: scene
				}, {
					path: '/job',
					name: 'job',
					component: job
				}, {
					path: '/dispute',
					name: 'dispute',
					component: dispute
				}, {
					path: '/examine',
					name: 'examine',
					component: examine
				}, {
					path: '/about',
					name: 'about',
					component: about
				}, 
			]
		},
		{
			path: '/xktv2', 
			component: BlankLayout,
			children: [
				{
					path: '',
					name: 'ktv',
					component: ktv2
				}
			]
		}, 
	]
})
